import { directives } from '@/framework';

export default {
  install(Vue) {
    directives(Vue, []);
  },
};



// WEBPACK FOOTER //
// ./src/directives/index.js